import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { appConfig } from '../../../../brands/_current/config/app-config'

@Component({
  selector: 'app-card-layout-content-header',
  templateUrl: './card-layout-content-header.component.html',
  styleUrls: ['./card-layout-content-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutContentHeaderComponent {
  @Input() noLogo = false
  logo = appConfig.core.cardLayoutLogo
  brand = appConfig.core.brandName

  constructor() {}
}
